<template>
	<div class="page-container-wrapper">
		<div v-if="withCloseButton" :class="pageContainerHomeButtonClass" @click="onClick">
			<CloseOutlined class="page-container-home-button-icon" />
		</div>
		<div :class="pageContainerClass">
			<slot></slot>
		</div>
	</div>
	<BackTop :target="() => wrapper" />
</template>

<script>
import { computed, toRef } from 'vue';
import { BackTop } from 'ant-design-vue';
import { CloseOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';

import { useRouter } from 'vue-router';

import { useSessionStore } from '@/stores/session';
import { useProvideInjectWrapper } from '@/utils/useProvideInject';
import { useLocaleData } from '@/locales/useLocaleData';

export default {
	components: {
		BackTop, CloseOutlined,
	},
	props: {
		withCloseButton: {
			type: Boolean,
			default: true,
		},
		withPadding: {
			type: Boolean,
			default: true,
		},
		narrow: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const { injectValue } = useProvideInjectWrapper;
		const wrapper = injectValue();
		const { localeData } = useLocaleData();
		const pageContainerHomeButtonClass = computed(() => 'page-container-home-button-' + localeData.value.direction);
		const withPaddingRef = toRef(props, 'withPadding');
		const narrowRef = toRef(props, 'narrow');
		const pageContainerClass = computed(() => ({
			'page-container': true,
			'page-container-padding': withPaddingRef.value,
			'page-container-narrow': narrowRef.value,
		}));
		const router = useRouter();
		const sessionStore = useSessionStore();
		const onClick = () => {
			router.push({ name: sessionStore.closeButtonRoute || 'home-map' });
		};
		return {
			wrapper,
			pageContainerHomeButtonClass,
			pageContainerClass,
			colorDefault: Consts.COLORS.dark0,
			colorActive: 'white',
			bgDefault: 'white',
			paddingMd: Consts.CSS.paddingMd,
			onClick,
		};
	}
}
</script>

<style scoped>
.page-container-wrapper {
	position: relative;
}
.page-container {
	background-color: white;
	box-shadow: 0px 2px 9px #444;
	border-radius: 5px;
	overflow: hidden;
}
.page-container-padding {
	padding: v-bind(paddingMd);
}
.page-container-narrow {
	overflow-x: hidden;
	overflow-y: auto;
	max-height: calc(100vh - 106px);
}
.page-container-home-button-icon {
	font-size: 14px;
}
.page-container-home-button-ltr,
.page-container-home-button-rtl {
	position: absolute;
	inset-block-start: 0;
	inset-inline-end: 0;
	box-shadow: 0px 1px 6px #444;
	cursor: pointer;
	padding: 4px 7px 2px;
	border-radius: 8px;
	color: v-bind(colorDefault);
	background-color: v-bind(bgDefault);
	z-index: 2;
}
.page-container-home-button-ltr {
	transform: translate(50%, -55%);
}
.page-container-home-button-rtl {
	transform: translate(-50%, -55%);
}
.page-container-home-button-ltr:hover,
.page-container-home-button-rtl:hover {
	color: v-bind(colorActive);
	background-color: var(--ant-primary-color-hover, #1890ff);
}
@media (max-width: 900px) {
	.page-container-home-button-ltr,
	.page-container-home-button-rtl {
		inset-inline-end: 50%;
	}
}
</style>
